export default "__VITE_ASSET__9bf8080b__"